export const langSpeedChart = {
  fr: {
    apply: 'Appliquer',
    cancelAll: 'Tout annuler',
    see: 'Voir les stats',
    save: 'Enregistrer ',
    registeredOnly: 'Réservé aux utilisateurs enregistrés',
  },
  eng: {
    apply: 'Apply',
    cancelAll: 'Cancel all',
    see: 'View stats',
    save: 'Save ',
    registeredOnly: 'Registered users only',
  },
}
